// src/services/api.js
import axios from 'axios';

// Ursprüngliche Logik auskommentiert, falls sie später benötigt wird:
// const API_URL = process.env.NODE_ENV === 'production' 
//   ? 'http://localhost:8000'  // Für lokale Entwicklung
//   : '/api';  // Für Produktion (Apache Proxy)

// API_URL fest auf localhost setzen
const API_URL = '/api';

const ApiService = {
  // Upload a PDF file
  uploadPDF: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      const response = await axios.post(`${API_URL}/upload/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  },
  
  // Start analysis of an uploaded PDF
  startAnalysis: async (fileId, options = {}, originalFilename = null) => {
    try {
      const url = `${API_URL}/analyze/${fileId}`;
      
      // Prepare request body with cache options and original filename
      const requestBody = {
        use_cache: options.useCache !== false // Default to true if not specified
      };
      
      if (options.fileHash) {
        requestBody.file_hash = options.fileHash;
      }

      // Add original_filename if provided
      if (originalFilename) {
        requestBody.original_filename = originalFilename;
      }
      
      console.log('Starting analysis with body:', requestBody); // Log the request body
      const response = await axios.post(url, requestBody);
      return response.data;
    } catch (error) {
      console.error('Error starting analysis:', error);
      throw error;
    }
  },
  
  // Get the status of an analysis
  getAnalysisStatus: async (taskId) => {
    try {
      console.log(`Fetching status for task: ${taskId}`);
      const response = await axios.get(`${API_URL}/status/${taskId}`);
      
      // Log the raw response for debugging
      console.log('Raw API response:', response);
      
      // Ensure progress is a number
      const data = response.data;
      if (data && typeof data.progress !== 'undefined') {
        // Convert progress to a number if it's a string
        if (typeof data.progress === 'string') {
          data.progress = parseInt(data.progress, 10) || 0;
        }
        
        // Ensure progress is a number between 0 and 100
        data.progress = Math.max(0, Math.min(100, data.progress));
        
        console.log('Processed status data:', data);
      }
      
      return data;
    } catch (error) {
      console.error('Error retrieving analysis status:', error);
      throw error;
    }
  },
  
  // Get the results of a completed analysis
  getAnalysisResults: async (taskId) => {
    try {
      const response = await axios.get(`${API_URL}/results/${taskId}`);
      console.log('Full analysis results:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error retrieving analysis results:', error);
      throw error;
    }
  },
  
  // Force a file to be reanalyzed by deleting it from the cache
  deleteFromCache: async (fileHash) => {
    try {
      const response = await axios.delete(`${API_URL}/cache/${fileHash}`);
      return response.data;
    } catch (error) {
      console.error('Error removing file from cache:', error);
      throw error;
    }
  },
  
  // Check if a file exists in the cache
  checkCache: async (fileHash) => {
    try {
      const response = await axios.get(`${API_URL}/cache/${fileHash}`);
      return response.data;
    } catch (error) {
      console.error('Error checking cache status:', error);
      throw error;
    }
  },
  
  // List all entries in the cache
  listCache: async () => {
    try {
      const response = await axios.get(`${API_URL}/cache`);
      return response.data;
    } catch (error) {
      console.error('Error listing cache entries:', error);
      throw error;
    }
  },

  // Send the investor summary PDF via email
  sendSummaryEmail: async (analysisId, recipientEmail) => {
    try {
      const response = await axios.post(`${API_URL}/api/analysis/${analysisId}/send_summary_email`, {
        recipient_email: recipientEmail,
      });
      return response.data; // Should contain { message: "Email sending process initiated." }
    } catch (error) {
      console.error('Error sending summary email:', error);
      // Try to return error details from the backend if available
      throw error.response?.data || error;
    }
  }
};

export default ApiService;
